import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface DualProductEntityParams {
  dualProductDistributors: number[];
}
export class DualProductEntity extends BaseEntityClass {
  dual_product_distributors: number[];
  constructor(params: DualProductEntityParams) {
    super();
    this.type = "dual_product";
    this.entity_version = 2;
    this.dual_product_distributors = params.dualProductDistributors;
  }
}
